import { SpollerAnimation } from "@plugins";

const collectionTags = document.querySelectorAll(".js-collection-tags-inner");

if (collectionTags) {
    window.addEventListener("load", () => initCollectionTagsInners(collectionTags));
}

function initCollectionTagsInners(inners) {
    const spollerAnimation = new SpollerAnimation();

    inners.forEach((item) => {
        const collectionTagsTitle = item.querySelector(".js-collection-tags-title");
        const block = item.querySelector(".js-collection-tags-list");

        if (block && collectionTagsTitle) {
            collectionTagsTitle.addEventListener("click", () => {
                if (item.classList.contains("active")) {
                    item.classList.remove("active");
                    spollerAnimation.slideUp(block, 100);
                } else {
                    item.classList.add("active");
                    spollerAnimation.slideDown(block, 250);
                }
            });
        }
    });
}
